<template>
  <div class="row">
    <div class="col-md-12">
      <div class="block-white block-white--scan">
        <div class="block-white__wrap">
          <div class="block-white__icon">
            <i class="icon icon-scan"></i>
          </div>
          <div
              class="block-white__content block-white__content--scan spinner-wrapper"
              v-if="loading"
          >
            <div class="loading-block">
              {{ messages.select_risk_location_loading }}
              <span class="spinner"></span>
            </div>
          </div>
          <div
              class="block-white__content block-white__content--scan"
              v-if="!loading"
          >
            <h2>{{ messages.select_risk_location_title }}</h2>
            <p>{{ messages.select_risk_location_description }}<br /><br /></p>

            <div v-if="locations.length === 0">
              {{ messages.select_risk_location_no_locations }}
            </div>

            <div v-for="(location, index) in locations" :key="location.scanId">
              <h5>{{organizationName}} - {{location.locationAddress ? location.locationAddress : location.riskAddress}} ({{location.targetGroupCode}})</h5>

              <ul class="basic-list" v-if="location.scanId">
                <li>{{messages.select_risk_location_measure_conditional}}
                  ({{location.conditionalMeasureCount}})
                </li>
                <li>{{messages.select_risk_location_measure_necessary}}
                  ({{location.necessaryMeasureCount}})
                </li>
                <li>{{messages.select_risk_location_measure_advice}} ({{location.adviceMeasureCount}})
                </li>
                <li>{{messages.select_risk_location_measure_satisfied}}
                  ({{location.satisfiedMeasureCount}})
                </li>
                <li>
                  <a
                      class="btn btn--icon-right"
                      href="javascript:void(0)"
                      @click.prevent="goToRiskOverview(location)"
                  >
                    <span>{{ messages.select_risk_location_button }}</span>
                    <i class="icon-next"></i>
                  </a>
                </li>
              </ul>
              <ul class="basic-list" v-else>
                <li>{{ messages.select_risk_location_no_active_scan }}</li>
                <li>
                  <a
                      class="btn btn--icon-right"
                      href="javascript:void(0)"
                      @click.prevent="goToRiskOverview(location)"
                  >
                    <span>{{ messages.select_risk_location_to_overview }}</span>
                    <i class="icon-next"></i>
                  </a>
                </li>
              </ul>

              <hr v-if="index < locations.length - 1" />
            </div>
          </div>
          <div class="block-white__image">
            <img :src="imageMediaItem.leadImageUrl" :alt="imageMediaItem.title"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Api from "./select-risk-location.api";
import { Api as CoreApi, Mixins } from "@bvm/core";

const ALLOWED_SCAN_LOCATION_STATUSES = ["SUBMITTED", "COMPLETED"];

export default {
  name: "select-risk-location",
  mixins: [Mixins.Lang, Mixins.Roles],
  data() {
    return {
      messageKeys: [
        "select_risk_location_loading",
        "select_risk_location_title",
        "select_risk_location_description",
        "select_risk_location_measure_conditional",
        "select_risk_location_measure_necessary",
        "select_risk_location_measure_advice",
        "select_risk_location_measure_satisfied",
        "select_risk_location_button",
        "select_risk_location_failure_retrieve_locations",
        "select_risk_location_failure_retrieve_status_image",
        "select_risk_location_no_locations",
        "select_risk_location_no_active_scan",
        "select_risk_location_to_overview"
      ],
      loading: true,
      organizationName: "",
      locations: [],
      imageMediaItem: {}
    };
  },
  created() {
    this.fetchImageSrc();
    this.organizationName = window.Bovemij?.CurrentProfile?.organization?.name;

    CoreApi.Auth.get()
        .then(data => this.roles = data)
        .then(this.getRiskLocations)
        .catch(error => CoreApi.Notification.notifyFailure(error, "Error retrieving roles"));
  },
  methods: {
    getRiskLocations() {
      Api.getRiskLocations()
          .then((response) => this.showRiskLocations(response.data))
          .catch((error) => CoreApi.Notification.notifyFailure(error, this.messages.select_risk_location_failure_retrieve_locations))
          .finally(() => this.loading = false);
    },
    fetchImageSrc() {
      Api.getMediaItem("SELECT_RISK_LOCATION_IMAGE")
          .then((response) => this.imageMediaItem = response.data || {})
          .catch((error) => CoreApi.Notification.notifyFailure(error, this.messages.select_risk_location_failure_retrieve_status_image));
    },
    showRiskLocations(locations) {
      let filteredLocations = locations
          .filter(location => location.riskScanType === "SELF_SERVICE" || ALLOWED_SCAN_LOCATION_STATUSES.includes(location.riskScanStatus));

      // Filter out locations with no scan for non employees
      if (!this.hasAnyRoles("OP_ACCOUNT_MANAGER", "OP_RISK_PREVENTION_PLANNER", "OP_ACCEPTANCE", "OP_SALES")) {
        filteredLocations = filteredLocations.filter(location => location.scanId);
      }

      // We could receive duplicates, so eliminate via locationHash
      this.locations = [...new Map(filteredLocations.map(item => [item.locationHash, item])).values()];

      if (this.locations.length === 1) {
        this.goToRiskOverview(this.locations[0]);
      }
    },
    goToRiskOverview(location) {
      Api.selectLocation(location.locationHash);
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-block {
  position: absolute;
  top: 50%;
  left: 25%;

  .spinner {
    position: relative;
    padding-right: 50px;
  }
}
</style>
